import createIcon from '../../createIcon';

/**
 * @component @name Fluorescent
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuMDAzOSA5SDUuMDAzOTNWMTVIMTkuMDAzOVY5WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEzLjAwMzkgMkgxMS4wMDM5VjVIMTMuMDAzOVYyWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE5LjA4IDQuNTk2NDhMMTcuMjkwMyA2LjM5ODg3TDE4LjcwOTUgNy44MDgwN0wyMC40OTkyIDYuMDA1NjhMMTkuMDggNC41OTY0OFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xMy4wMDM5IDE5SDExLjAwMzlWMjJIMTMuMDAzOVYxOVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNy4yOTM5IDE3LjcxTDE5LjA4MzkgMTkuNTFMMjAuNTAzOSAxOC4wOUwxOC43MDM5IDE2LjNMMTcuMjkzOSAxNy43MVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik00LjkwNTc3IDQuNjAxOTZMMy40OTg2NSA2LjAwOTA5TDUuMjg3NjEgNy43OTgwNkw2LjY5NDc0IDYuMzkwOTNMNC45MDU3NyA0LjYwMTk2WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTUuMjk4NDggMTYuMjg2NUwzLjQ5NjA5IDE4LjA3NjJMNC45MDUyOSAxOS40OTU0TDYuNzA3NjggMTcuNzA1N0w1LjI5ODQ4IDE2LjI4NjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Fluorescent = createIcon('Fluorescent', [
  ['path', { d: 'M19.0039 9H5.00393V15H19.0039V9Z', key: 'l88uol' }],
  ['path', { d: 'M13.0039 2H11.0039V5H13.0039V2Z', key: 'ernuwy' }],
  [
    'path',
    {
      d: 'M19.08 4.59648L17.2903 6.39887L18.7095 7.80807L20.4992 6.00568L19.08 4.59648Z',
      key: 'scs1ct',
    },
  ],
  ['path', { d: 'M13.0039 19H11.0039V22H13.0039V19Z', key: 'qk80on' }],
  [
    'path',
    { d: 'M17.2939 17.71L19.0839 19.51L20.5039 18.09L18.7039 16.3L17.2939 17.71Z', key: 'me4vt4' },
  ],
  [
    'path',
    {
      d: 'M4.90577 4.60196L3.49865 6.00909L5.28761 7.79806L6.69474 6.39093L4.90577 4.60196Z',
      key: '160e0s',
    },
  ],
  [
    'path',
    {
      d: 'M5.29848 16.2865L3.49609 18.0762L4.90529 19.4954L6.70768 17.7057L5.29848 16.2865Z',
      key: '98bm1g',
    },
  ],
]);

export default Fluorescent;
